import { Avatar } from '@mui/material';
import styled from 'styled-components';

import { Styling } from '../../constants';

const teamSize = 24;

export const TeamContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
`;

export const TeamListContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DialogContentContainer = styled.div`
  display: flex;
  font-size: 14px;
  padding: ${Styling.DEFAULT_SPACING}px;
  flex-direction: column;
  justifyContent: space-around;
  paddingBottom: 20px;
  height: 400px;
  overflow: overlay;
`;

export const StyledAvatar = styled(Avatar)`
  width: ${teamSize}px !important;
  height: ${teamSize}px !important;
  margin-right: ${Styling.DEFAULT_SPACING}px;
`;
